module.exports = __webpack_public_path__ + "static/the_covid_tracker-a1439ff71a8af34abccaeebefefe0318.png";